// extracted by mini-css-extract-plugin
export default {"studentsList":"StudentsList_studentsList__bdGcI","studentItem":"StudentsList_studentItem__NO6jQ"};